import { render } from "./QuillEditor.vue?vue&type=template&id=2dec54df&scoped=true&ts=true"
import script from "./QuillEditor.vue?vue&type=script&lang=ts"
export * from "./QuillEditor.vue?vue&type=script&lang=ts"

import "./QuillEditor.vue?vue&type=style&index=0&id=2dec54df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dec54df"]])

export default __exports__